import { GroupMember, CurrentMember } from "suus-api"
import { groupMemberApi } from "store/api"

export const fetchGroupMemberByCurrentMember = async (
  member: CurrentMember
): Promise<GroupMember> => {
  const id = member?.personal_record?.id
  if (id) {
    const response = await groupMemberApi.getGroupMember(id.toString())
    return response.data
  } else {
    return undefined
  }
}
